import request from '../../../../api/request';
import { TutorsResponse } from '../parts/studentTutors/types';

const TUTORS = {
  GET_TUTORS: (studentId: string | number) =>
    `teacher-portal/student-file/student-tutors/${studentId}`,
};

export function getStudentTutors(studentId: number | string) {
  return request<TutorsResponse>(TUTORS.GET_TUTORS(studentId));
}
